<template>
    <v-layout align-center justify-center>
        <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
                <v-toolbar color="black" dark>
                    <v-toolbar-title>Settings</v-toolbar-title>
                </v-toolbar>
                
                <v-card-text>
                    
                    <!-- ERROR MESSAGE -->
                    <v-alert
                        :value="errorMsg !== false"
                        type="error"
                        :dismissible="true"
                    >
                        {{ errorMsg }}
                    </v-alert>
                    <br />
                    <v-alert
                        v-model="submitSuccess"
                        type="success"
                        :dismissible="true"
                    >
                        Changes saved successfully!
                    </v-alert>
                    <br />

                    <v-form @submit="submit">
                        <v-text-field
                            v-model="email"
                            label="Email"
                            required
                        ></v-text-field>

                        <v-switch v-model="changePassword" color="primary" label="Change password" />

                        <v-expand-transition>
                            <div v-if="changePassword">
                                <v-text-field
                                    v-model="password"
                                    type="password"
                                    label="Password"
                                    required
                                ></v-text-field>

                                <v-text-field
                                    v-model="password2"
                                    type="password"
                                    label="Confirm Password"
                                    required
                                ></v-text-field>
                            </div>
                        </v-expand-transition>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn right color="info" type="submit" :loading="isLoading">Submit</v-btn>
                        </v-card-actions>
                    </v-form>

                </v-card-text>

            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    export default {

        mounted: function(){
            this.redirectIfNotLoggedIn();

            this.email = this.$store.state.auth.email;
        },

        data: function(){
            return {
                email               : "",
                changePassword      : false,
                password            : "",
                password2           : "",
                isLoading           : false,
                errorMsg            : false,
                submitSuccess       : false
            };
        },

        methods: {
            submit: function(event){
                if (event) event.preventDefault();

                if(this.isLoading) return false;

                this.isLoading = true;
                this.errorMsg = false;

                this.$store.dispatch('auth/updateSettings', {
                    email           : this.email,
                    changePassword  : this.changePassword,
                    password        : this.password,
                    password2       : this.password2
                }).then(()=>{

                    this.submitSuccess = true;
                    this.password = "";
                    this.password2 = "";
                    this.changePassword = false;

                }).catch((err)=>{

                    this.errorMsg = err.response.data;

                }).finally(()=>{
                    this.isLoading = false;
                });
                // return false;
            }
        }
    }
</script>
